export default __webpack_public_path__ + "static/media/KWG.02ddaa57.png";